import { render } from "./articleRight.vue?vue&type=template&id=17c845ff&scoped=true"
import script from "./articleRight.vue?vue&type=script&lang=js"
export * from "./articleRight.vue?vue&type=script&lang=js"

import "./articleRight.vue?vue&type=style&index=0&id=17c845ff&lang=scss&scoped=true"
import "./articleRight.vue?vue&type=style&index=1&id=17c845ff&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c845ff"]])

export default __exports__